import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Table, Form, Input, Row, Col, Modal, message } from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
const StoreManage = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    stationId,
  });
  const [tableSource, setTableSource] = useState({});
  const [inputList] = useState([
    {
      label: "名称:",
      name: "name",
      message: "请输入名称",
      span: 8,
      labelCol: 6,
    },
  ]);

  const columns = [
    {
      title: "名称",
      dataIndex: "name",
      align: "center",
      key: "name",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "单元值",
      dataIndex: "value",
      align: "center",
      key: "value",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const getListPages = () => {
    setLoading(true);
    SystemApi.processUnitList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.processUnitDelete({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          if (tableSource.data.length == 1 && tableSource.pageNum > 1) {
            searchParams({
              ...searchParams,
              pageNum: searchParams.pageNum - 1,
            });
          } else {
            getListPages();
          }
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    const { id, value, name } = obj;
    setVisible(true);
    setEditId(id);
    form.setFieldsValue({
      partList: [
        {
          name,
          value,
        },
      ],
    });
  };

  const addRecord = () => {
    setVisible(true);
    form.setFieldsValue({
      partList: [{}],
    });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const arr = values.partList.map((item) => {
        return {
          name: item.name,
          value: item.value,
          stationId,
          unitPic:
            "https://wushan.test.somorn.com/cfs/png/2509/20/1736604900781068288.png",
        };
      });
      if (editId) {
        setConfirmLoading(true);
        SystemApi.processUnitUpdate({ ...arr[0], id: editId }).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("修改成功");
          cancel();
          getListPages();
        });
      } else {
        setConfirmLoading(true);
        SystemApi.processUnitInsert(arr).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    setSearchParams({
      ...searchParams,
      ...values,
      pageNum: 1,
      pageSize: 10,
    });
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm span={6} inputList={inputList} onSearch={search} />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={addRecord}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum == 0 ? 1 : tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          width={1200}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.List name="partList">
              {(fields, { add, remove }) => (
                <Row>
                  {fields.map((field) => (
                    <Col
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        paddingBottom: 10,
                        borderBottom: "1px solid #ddd",
                      }}
                      span={24}
                      key={field.key}
                    >
                      <Row gutter={20}>
                        <Col span={20}>
                          <Row gutter={20}>
                            <Col span={12}>
                              <Form.Item
                                label="名称"
                                name={[field.name, "name"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请填写名称!",
                                  },
                                ]}
                              >
                                <Input placeholder={"请填写名称"} />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="单元值"
                                name={[field.name, "value"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "请填单元值!",
                                  },
                                ]}
                              >
                                <Input placeholder={"请填单元值"} />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={2}>
                          {fields.length > 1 && (
                            <Button
                              type="primary"
                              danger
                              onClick={() => remove(field.name)}
                            >
                              移除
                            </Button>
                          )}
                        </Col>
                        {!editId && (
                          <Col span={2}>
                            <Button type="primary" onClick={add}>
                              添加
                            </Button>
                          </Col>
                        )}
                      </Row>
                    </Col>
                  ))}
                </Row>
              )}
            </Form.List>
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(StoreManage);
